import { UserData } from 'models';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import api, { VOTE_API_ACTION_TYPE } from 'util/api';

export default function useSurvey() {
  const userData: UserData | null = useSelector((state: RootState) => state.user.data);
  const cms = useSelector((state: RootState) => state.widget.cms);
  const { apiKey, version_id: versionId } = cms.settings;
  const { code, token } = userData || {};

  const submitSurvey = useCallback(
    async (multipleChoice: any, writeIns: any) => {
      const query = {
        apiKey,
        timestamp: Date.now(),
        action_type: VOTE_API_ACTION_TYPE.SUBMIT_SURVEY,
        token,
        code,
        ...multipleChoice,
      };

      return await api.postToVoteApi(query, writeIns, versionId);
    },
    [apiKey, versionId, code, token]
  );

  const getSurvey = useCallback(async () => {
    const payload = {
      apiKey,
      timestamp: Date.now(),
      action_type: VOTE_API_ACTION_TYPE.GET_SURVEY,
      token,
      code,
    };

    return await api.postToVoteApi(payload, null, versionId);
  }, [apiKey, versionId, code, token]);

  return {
    submitSurvey,
    getSurvey,
  };
}
